import api from './api';

export const authService = {
  login: async (email, password) => {
    const res = await api.post('/Auth/Login', { email, password });
    return res.data.data;
  },

  register: async (payload) => {
    const res = await api.post('/Auth/Register', payload);
    return res.data.data;
  },
};
